import { render, staticRenderFns } from "./waschepacket.vue?vue&type=template&id=1016e56d&"
import script from "./waschepacket.vue?vue&type=script&lang=js&"
export * from "./waschepacket.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1016e56d')) {
      api.createRecord('1016e56d', component.options)
    } else {
      api.reload('1016e56d', component.options)
    }
    module.hot.accept("./waschepacket.vue?vue&type=template&id=1016e56d&", function () {
      api.rerender('1016e56d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-4bHD2y2JfW43P/JS/comp/waschepacket.vue"
export default component.exports